var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"omapi-subscribers-page omapi-subscribers-segments"},[(!_vm.hasTags)?_c('monsterleads-segments-no-segments'):_c('monsterleads-segments-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }